import { render, staticRenderFns } from "./ConfirmLabManagerSender.vue?vue&type=template&id=7c4156ca"
import script from "./ConfirmLabManagerSender.vue?vue&type=script&lang=js"
export * from "./ConfirmLabManagerSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports